// チームアイコン（Team.icon）は任意項目で、未設定なら null のまま保存される。
// 表示が欠けないよう既定の絵文字と表示ラベルの組み立てをここに集約する。
// 新規作成時はサーバ側（backend AdminService.createTeam）でも同じ絵文字が入るので、
// 値を変えるときは backend の DEFAULT_TEAM_ICON も揃えること。
export const DEFAULT_TEAM_ICON = '👥';

/** チームを「アイコン + 名前」で表示するときの共通ラベル。 */
export function teamLabel(team: { icon?: string | null; name: string }): string {
  return `${team.icon || DEFAULT_TEAM_ICON} ${team.name}`;
}
